import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { generateClient } from "aws-amplify/api";
import {
  listAgreements,
  listContents,
  listPaymentDetails,
} from "../../graphql/queries";
import { deleteContent } from "../../graphql/mutations";
import { useNavigate } from "react-router-dom";
import { Delete, Edit } from "@mui/icons-material";
import Label from "../../components/Label";
import CustomDataGrid from "../../components/CustomDataGrid";
import Box from "@mui/material/Box";
import moment from "moment";
import ActionsPopover from "../../components/actionsPopover";import CreateContentModal from "../../components/Content/CreateContentModal";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
  dataGridContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  dataGrid: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      "& .MuiDataGrid-columnHeaders": {
        display: "none",
      },
      "& .MuiDataGrid-cell": {
        display: "block",
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 2),
        "&:not(:last-child)": {
          borderBottom: 0,
        },
        "&:before": {
          content: "attr(data-field)",
          fontWeight: "bold",
          marginBottom: theme.spacing(1),
        },
      },
    },
  },
}));

const Payments = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const client = generateClient();
  const [contentList, setContentList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCategory();
  }, []);

  const fetchCategory = async () => {
    try {
      setLoading(true);
      const response = await client.graphql({
        query: listAgreements,
      });
      const contentList = response.data.listAgreements.items;
      setContentList(contentList);
    } catch (error) {
      console.error("Error fetching category:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { field: "nameOfSupplier", headerName: "Name of Supplier", flex: 1 },

    {
      field: "dateOfAgreement",
      headerName: "Date Of Agreement",
      flex: 1,
      renderCell: (params) => {
        return moment(params?.value).format("DD MMM YYYY");
      },
    },
    {
      field: "daysOfAgreement",
      headerName: "Term Of Agreement",
      flex: 1,
      renderCell: (params) => `${params?.value / 30} months`,
    },
    {
      field: "contractValue",
      headerName: "Contract Value ($)",
      flex: 1,
      renderCell: (params) => (
        <div style={{ textAlign: "right", width: "100%" }}>{params?.value}</div>
      ),
    },
    { field: "paymentPlan", headerName: "Payment Plan", flex: 1 },
    { field: "paymentTerm", headerName: "Payment Term", flex: 1 },
    {
      field: "paymentStatus",
      headerName: "Payment Status",
      flex: 1,
      renderCell: (params) => (
        <div style={{ textAlign: "right" }}>{params?.value}</div>
      ),
    },
    {
      field: "amountPaid",
      headerName: "Amount Paid ($)",
      flex: 1,
      renderCell: (params) => (
        <div style={{ textAlign: "right", width: "100%" }}>{params?.value}</div>
      ),
    },
    {
      field: "paymentDueDate",
      headerName: "Payment Due Date",
      flex: 1,
      renderCell: (params) => moment(params?.value)?.format("DD MMM YYYY"),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <ActionsPopover
          itemId={params?.row?.id}
          viewPath={`/payment/${params?.row?.id}`}
        />
      ),
    },
  ];

  const updateContentById = async (contentId) => {
    navigate(`/content/update`, {
      state: {
        userId: contentId,
      },
    });
  };

  const deleteContentById = async (contentId) => {
    try {
      await client.graphql({
        query: deleteContent,
        variables: { input: { id: contentId } },
      });
      fetchCategory();
    } catch (err) {
      console.log("Error deleting Category:", err);
    }
  };

  return (
    <>
      <Typography variant="h5" fontWeight={500}>
        Payment Status
      </Typography>
      <Box marginTop={2}>
        <div className={classes.dataGridContainer}>
          <CustomDataGrid rows={contentList} columns={columns} pageSize={10} />
        </div>
      </Box>
    </>
  );
};

export default Payments;
